export default __webpack_public_path__ + "static/media/visita_v_eng.85a764f6.png";